import PropTypes from "prop-types";
import React from "react";
import relationships from "../../../../../config/shared_portal_relationships.json";
import FormField from "./FormField";

const RelationshipField = ({name, label, required}) => {
  return (
    <div className="row">
      <FormField label={label} type="select" name={name} options={relationships} colWidth={6} required={required} />
    </div>
  );
};

RelationshipField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};

RelationshipField.defaultProps = {
  required: false
};

export default RelationshipField;
